module.exports = __webpack_public_path__ + "img/42ne.41dcb738.svg";